import { Suspense } from "react"

import Section from "./Section"
import { sectionHeaderDefaultClasses } from "./SectionHeader"

import { useDealAsset } from "web/hooks/data"

export function DealAssetWithoutFetch({ dealAsset, ...rest }) {
  return <Section {...rest} data={dealAsset} />
}

export function DealAssetWithFetch({ dealAssetId, ...rest }) {
  const dealAsset = useDealAsset(dealAssetId)

  return <DealAssetWithoutFetch {...rest} dealAsset={dealAsset} />
}

export default function DealAsset(props) {
  const { dealAsset, dealAssetId } = props

  const hasDealAsset = !!dealAsset
  const dealAssetIsShallow = hasDealAsset && dealAsset.is_shallow

  const fetch = !hasDealAsset || dealAssetIsShallow

  return (
    <Suspense
      fallback={
        <div className={sectionHeaderDefaultClasses}>
          <div className="p-2">Loading Deal Asset Details...</div>
        </div>
      }
    >
      {!fetch && <DealAssetWithoutFetch {...props} />}
      {fetch && (
        <DealAssetWithFetch
          {...props}
          dealAssetId={dealAssetId || dealAsset.id}
        />
      )}
    </Suspense>
  )
}
